/**
 * Human-readable, SEO-friendly URL helpers.
 *
 * Products:   /product/hairy-lamb-skin-chews--<uuid>
 * Categories: /category/natural-treats--46
 *
 * The trailing id after the "--" separator keeps lookups exact and stable,
 * while the leading slug tells search engines what the page is about.
 * Legacy id-only URLs continue to resolve (and are canonicalised on load).
 */

export const slugify = (value: string | null | undefined): string =>
  (value || "")
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 70)
    .replace(/-+$/g, "");

const SEPARATOR = "--";

const withSlug = (slug: string, id: string | number) =>
  slug ? `${slug}${SEPARATOR}${id}` : String(id);

/** Extract the raw id from a slugged route param (handles legacy id-only params). */
export const idFromSlugParam = (param?: string | null): string => {
  if (!param) return "";
  const decoded = decodeURIComponent(param);
  const index = decoded.lastIndexOf(SEPARATOR);
  return index === -1 ? decoded : decoded.slice(index + SEPARATOR.length);
};

export const productPath = (
  product: { id: string; name?: string | null } | null | undefined,
): string => (product?.id ? `/product/${withSlug(slugify(product.name), product.id)}` : "/shop");

export const categoryPath = (
  category: { simple_id?: number | string | null; id?: number | string | null; name?: string | null } | null | undefined,
): string => {
  const id = category?.simple_id ?? category?.id;
  if (id === null || id === undefined || id === "") return "/categories";
  return `/category/${withSlug(slugify(category?.name), id)}`;
};

/** Absolute canonical URL for a path. */
export const absoluteUrl = (path: string) => `https://k9chews.com${path}`;
